/* CTA che scrollano a una sezione della stessa pagina.
   Sostituisce wine-club.js e ne generalizza la logica.

   Come funziona: i setting di tipo `url` di Shopify non accettano un'ancora
   (#...), quindi nel template mettiamo un URL valido e qui riscriviamo l'href
   dopo il caricamento. L'ancora diventa reale e lo scroll lo fa il browser:
   niente click da intercettare, niente handler scavalcabili.

   ATTENZIONE all'id della sezione: in un template JSON Shopify genera
   `shopify-section-template--<id_template>__<chiave>`, NON
   `shopify-section-<chiave>`. L'id del template cambia se il template viene
   ricreato, quindi cerchiamo per suffisso. */
(function () {
  var GAP = 20; /* respiro sotto l'header */

  /* chiave della sezione bersaglio -> frammento di href da riscrivere */
  var RULES = [
    { section: 'flex_grid_boxes',     match: '/collections/like-wine-club' },
    { section: 'contact_form_horeca',      match: '/pages/hai-unattivita' },
    { section: 'contact_form_personalizza', match: '/pages/personalizza-il-tuo-acquisto' },
    { section: 'rich_text_form_intro',      match: '/pages/newsletter' }
  ];

  /* diagnosi: in console `window.__scrollCta` */
  window.__scrollCta = { loaded: true, applied: [] };

  function findSection(key) {
    return document.querySelector(
      '[id$="__' + key + '"], #shopify-section-' + key
    );
  }

  function headerOffset() {
    var header = document.querySelector('.shopify-section-group-header-group');
    if (!header) return 0;
    var pos = window.getComputedStyle(header).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;
    return header.offsetHeight || 0;
  }

  function injectStyle(ids) {
    var style = document.getElementById('scroll-cta-style');
    if (!style) {
      style = document.createElement('style');
      style.id = 'scroll-cta-style';
      document.head.appendChild(style);
    }
    var margin = headerOffset() + GAP;
    style.textContent =
      'html { scroll-behavior: smooth; }\n' +
      ids.map(function (id) {
        return '#' + id + ' { scroll-margin-top: ' + margin + 'px; }';
      }).join('\n');
  }

  function apply() {
    var touched = [];

    RULES.forEach(function (rule) {
      var target = findSection(rule.section);
      if (!target || !target.id) return; /* bersaglio assente: link invariato */

      var links = document.querySelectorAll('a[href*="' + rule.match + '"]');
      var count = 0;
      for (var i = 0; i < links.length; i++) {
        if (links[i].getAttribute('data-scroll-cta') === '1') continue;
        /* non tocchiamo un href gia trasformato in ancora */
        if ((links[i].getAttribute('href') || '').charAt(0) === '#') continue;
        links[i].setAttribute('data-scroll-cta', '1');
        links[i].setAttribute('href', '#' + target.id);
        links[i].removeAttribute('target');
        count++;
      }

      touched.push(target.id);
      window.__scrollCta.applied.push({ section: rule.section, links: count });
    });

    if (touched.length) injectStyle(touched);
  }

  /* I link nei box informativi del form contatti devono essere i bottoni del
     tema. Il setting `content` di quei blocchi e di tipo richtext e Shopify
     scarta l'attributo class, quindi la applichiamo qui: cosi sono gli stessi
     bottoni del resto del sito, hover compreso, invece di un'imitazione.
     Tocchiamo solo i link che stanno da soli nel proprio paragrafo: un link
     dentro una frase deve restare un link. */
  function themeButtons() {
    var links = document.querySelectorAll('.contact-form__info a');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-theme-button') === '1') continue;
      if (a.classList.contains('button')) continue;
      var p = a.parentElement;
      if (!p || p.tagName !== 'P') continue;
      if (p.children.length !== 1) continue;
      if (p.textContent.trim() !== a.textContent.trim()) continue;
      a.setAttribute('data-theme-button', '1');
      a.classList.add('button', 'button--small', 'button--outline');
    }
  }

  function run() {
    apply();
    themeButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
})();